import React from "react";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Helmet from "../component/common/Helmet";
import TextLoop from "react-text-loop";
import HeaderThree from "../component/header/HeaderThree";
import FooterTwo from "../component/footer/FooterTwo";
import TabTwo from "../elements/tab/TabTwo";
import ContactThree from "../elements/contact/ContactThree";
import PortfolioList from "../elements/portfolio/PortfolioList";
import ServiceList from "../elements/service/ServiceList";
import BlogContent from "../elements/blog/BlogContent";
import moises from "./moises.png";

const SlideList = [
  {
    textPosition: "text-left",
    // category: "Seja muito bem-vindo!",
    description: "",
    buttonText: "",
    buttonLink: "",
  },
];
const PortfolioLanding = () => {
  let title = "About Me",
    description =
      "Se você não me conhece eu quero fazer uma rápida apresentação, sou Moisés Araujo, natural da cidade de Parnaíba, estado do Piauí e desde Junho de 2015 estou morando nos Estados Unidos, na cidade de New York, onde tenho me esforçado diariamente pra acumular conhecimento e maior número de experiências na área de educação financeira para fazer a diferença na vida das pessoas, compartilhando um pouco do que aprendi ao longo desses anos, para juntos sonharmos e celebrarmos a vida com mais liberdade. Por isso coloquei como minha missão, ajudar você na organização de suas finanças e fazer você manter uma relação mais saudável com o seu dinheiro.";
  const PostList = BlogContent.slice(0, 3);
  let descriptionOne =
    "Você sabe que precisa cuidar melhor do seu dinheiro, mas não sabe como se organizar? Não tem fórmula mágica, você precisa apenas ter paciência e confiar no processo. Daí as coisas vão acontecendo naturalmente. Lembre-se que dinheiro não é um simples papel, dinheiro é seu tempo de trabalho, seu esforço diário, seu suor de hora em hora, dinheiro é um futuro mais agradável, você precisa entender isso, então já te agradeço por ter chegado até aqui, pois isso mostra que você quer focar no seu crescimento pessoal.";
  return (
    <div className="active-dark">
      <Helmet pageTitle="Professor Moises" />

      <HeaderThree homeLink="/" logo="symbol-dark" color="color-black" />
      {/* Start Slider Area   */}
      <div id="home" className="fix">
        <div className="slider-wrapper">
          {/* Start Single Slide */}
          {SlideList.map((value, index) => (
            <div
              className="slide personal-portfolio-slider slider-paralax slider-style-3 d-flex align-items-center justify-content-center "
              key={index}
              style={{ paddingBottom: "15px" }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className={`inner ${value.textPosition}`}>
                      {value.category ? <span>{value.category}</span> : ""}
                      <h1 className="title">
                        Olá, Seja muito <br />
                        <TextLoop>
                          <span> Bem Vindo!</span>
                          {/* <span> Mentor</span> */}
                          {/* <span> Coach</span> */}
                        </TextLoop>{" "}
                        {/* <br></br>
                        Moises. */}
                      </h1>
                      {/* <h1 className="title">
                        Olá, Sou o <br />
                        <TextLoop>
                          <span> Professor</span>
                          <span> Mentor</span>
                          <span> Coach</span>
                        </TextLoop>{" "}
                        <br></br>
                        Moises.
                      </h1> */}
                      <p className="description" style={{ color: "white" }}>
                        {descriptionOne}
                      </p>

                      {value.description ? (
                        <p className="description">{value.description}</p>
                      ) : (
                        ""
                      )}

                      {value.buttonText ? (
                        <div className="slide-btn">
                          <a
                            className="rn-button-style--2 btn-primary-color"
                            href={`${value.buttonLink}`}
                          >
                            {value.buttonText}
                          </a>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {/* End Single Slide */}
        </div>
      </div>
      {/* End Slider Area   */}

      {/* Start About Area */}
      <div id="about" className="fix">
        <div className="about-area   bg_color--1">
          <div className="about-wrapper">
            <div className="container">
              <div className="row row--35 align-items-center">
                <div className="col-lg-5">
                  <div className="thumbnail">
                    {/* About me photo */}
                    <img className="w-100" src={moises} alt="About Images" />
                  </div>
                </div>
                <div className="col-lg-7">
                  <div className="about-inner inner">
                    <div className="section-title">
                      {/* <h2 className="title">{title}</h2> */}
                      <p className="description" style={{ color: "white" }}>
                        {description}
                      </p>
                      <p style={{ textTransform: "uppercase", color: "white" }}>
                        Desde já convido você para montarmos o seu plano de ação
                        pessoal.
                      </p>
                    </div>
                    {/* <div className="row mt--30">
                      <TabTwo tabStyle="tab-style--1" />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* End About Area */}

      {/* Start Service Area  */}
      {/* <div id="service" className="fix">
        <div className="service-area creative-service-wrapper ptb--120 bg_color--5">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title text-center service-style--3 mb--30 mb_sm--0">
                  <h2 className="title">My Awesome Service</h2>
                  <p>
                    There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration.
                  </p>
                </div>
              </div>
            </div>
            <div className="row creative-service">
              <div className="col-lg-12">
                <ServiceList
                  item="6"
                  column="col-lg-4 col-md-6 col-sm-6 col-12 text-left"
                />
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* End Service Area  */}

      {/* Start Portfolio Area */}
      {/* <div id="portfolio" className="fix">
        <div className="portfolio-area ptb--120 bg_color--1">
          <div className="portfolio-sacousel-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-title text-center service-style--3 mb--30 mb_sm--0">
                    <h2 className="title">My Latest Project</h2>
                    <p>
                      There are many variations of passages of Lorem Ipsum
                      available, but the majority have suffered alteration.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <PortfolioList
                  styevariation="text-center mt--40"
                  column="col-lg-4 col-md-6 col-sm-6 col-12"
                  item="6"
                />
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="view-more-btn mt--60 mt_sm--30 text-center">
                    <a className="rn-button-style--2 btn-solid" href="/blog">
                      <span>View More</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* End Portfolio Area */}

      {/* Start Blog Area */}
      {/* <div id="blog" className="fix">
        <div className="rn-blog-area ptb--120 bg_color--5 mb-dec--30">
          <div className="container">
            <div className="row align-items-end">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="section-title text-center">
                  <h2>Latest News</h2>
                  <p>
                    There are many variations of passages of Lorem Ipsum
                    available, <br />
                    but the majority have suffered alteration.
                  </p>
                </div>
              </div>
            </div>
            <div className="row mt--60 mt_sm--40">
              {PostList.map((value, i) => (
                <div className="col-lg-4 col-md-6 col-12" key={i}>
                  <div className="blog blog-style--1">
                    <div className="thumbnail">
                      <a href="/blog-details">
                        <img
                          className="w-100"
                          src={`/assets/images/blog/blog-${value.images}.jpg`}
                          alt="Blog Images"
                        />
                      </a>
                    </div>
                    <div className="content">
                      <p className="blogtype">{value.category}</p>
                      <h4 className="title">
                        <a href="/blog-details">{value.title}</a>
                      </h4>
                      <div className="blog-btn">
                        <a className="rn-btn text-white" href="/blog-details">
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div> */}
      {/* End Blog Area */}

      {/* Start COntact Area */}
      <div id="contact" className="fix">
        <div
          className="rn-contact-area  bg_color--1"
          style={{ padding: "10px 0px" }}
        >
          <ContactThree
            contactImages="/assets/images/about/about-9.jpg"
            contactTitle="AGENDE NOSSA REUNIÃO."
          />
        </div>
      </div>
      {/* End COntact Area */}

      <FooterTwo />
      {/* Start Back To Top */}
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
      {/* End Back To Top */}
    </div>
  );
};

export default PortfolioLanding;
